import TextField, { TextFieldProps } from '@mui/material/TextField';
import React from 'react';

const CustomTextField = (props) => <TextField {...props} />;

export default CustomTextField;
export type { TextFieldProps };
